import "./App.css";
import Header from "./Components/Header";
import RouteComponent from "./Router/router";
import Footer from "./Components/Footer";
import ScrollToTop from "./scrolltotop";
import { Toaster } from "react-hot-toast";
// import Whatsapp from "./Components/Whatsapp";

function App() {
  return (
    <>
      <Toaster />
      <ScrollToTop />
      <Header />
      <div className="overFlowHidden">
        <RouteComponent />
      </div>
      {/* <Whatsapp/> */}
      <Footer />
    </>
  );
}

export default App;
